import RoleEnum from '../enum/RoleEnum';

const RoleHierarchy: Record<RoleEnum, RoleEnum[]> = {
  [RoleEnum.ROLE_SUPER_ADMIN]: [RoleEnum.ROLE_ADMIN],
  [RoleEnum.ROLE_ADMIN]: [RoleEnum.ROLE_USER],
  [RoleEnum.ROLE_USER]: [],
};

export default RoleHierarchy;
